













import Vue from 'vue';
import { Team, User } from '../models';
import { TabType } from '@/store/chatTab.store';
export default Vue.extend({
  props: {
    tab: Object,
  },
  methods: {
    getTabName({type, entityId}: any) {
      switch (type) {
        case TabType.RUNNING:
          return 'Em andamento';
        case TabType.WAITING:
          return 'Aguardando';
        case TabType.FISINHED:
          return 'Finalizadas';
        case TabType.ALL:
          return 'Todas';
        case TabType.TEAM:
          return `Time - ${this.$store.state.team.teams &&
            this.$store.state.team.teams.find((t: Team) => t.objectId === entityId).name || ''}`;
        case TabType.USER:
          return `Usuário - ${this.$store.state.user.users &&
            this.$store.state.user.users.find((u: User) => u.objectId === entityId).name || ''}`;
      }
    },
  },
});
